import React from "react";
import { PercentRing } from "./PercentRing";

const fmtDur = (s) => { const n = Number(s || 0); return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`; };

/* 坐席百分比指标行 */
export function AgentMetrics({ m, zh }) {
  if (!m) return null;
  const rings = [
    { k: "answer", v: m.answerRate, label: zh ? "接通率" : "Answer rate", sub: zh ? `${m.answered} / ${m.calls} 通` : `${m.answered} / ${m.calls} calls`, color: "#16a34a" },
    { k: "recording", v: m.recordingRate, label: zh ? "有录音率" : "Recorded", sub: zh ? `${m.recordings} 通有录音` : `${m.recordings} recordings`, color: "#0ea5e9" },
    { k: "score", v: m.avgScore, label: zh ? "AI 话术评分" : "AI script score", sub: zh ? `${m.scored} 通已评分` : `${m.scored} scored`, color: "#d97706" },
    { k: "high", v: m.highIntentRate, label: zh ? "高意向占比" : "High intent", sub: zh ? `${m.highIntent} / ${m.tagged} 通` : `${m.highIntent} / ${m.tagged}`, color: "#4F6BFF" },
    { k: "callback", v: m.callbackRate, label: zh ? "待回拨完成率" : "Callbacks done", sub: zh ? `${m.callbacksDone} / ${m.missedInbound} 未接` : `${m.callbacksDone} / ${m.missedInbound} missed`, color: "#7c3aed" },
    { k: "stars", v: m.ratingPct, label: zh ? "经理评分" : "Manager rating", sub: m.avgStars ? `${m.avgStars} ★ · ${m.rated}${zh ? " 通" : ""}` : (zh ? "尚未评分" : "not rated"), color: "#0f172a" },
  ];
  const stats = [
    { k: "calls", label: zh ? "通话总数" : "Calls", v: m.calls },
    { k: "out", label: zh ? "外呼 / 来电" : "Out / In", v: `${m.outbound} / ${m.inbound}` },
    { k: "dur", label: zh ? "通话总时长" : "Talk time", v: fmtDur(m.totalDurationSec) },
    { k: "avgdur", label: zh ? "平均时长" : "Avg duration", v: fmtDur(m.avgDurationSec) },
    { k: "sms", label: zh ? "短信 发 / 收" : "SMS out / in", v: `${m.smsOut} / ${m.smsIn}` },
  ];
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4" data-testid="agent-metrics">
      <div className="flex flex-wrap justify-around gap-3">
        {rings.map((r) => <PercentRing key={r.k} value={r.v} label={r.label} sub={r.sub} color={r.color} testid={`agent-ring-${r.k}`} />)}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mt-4 pt-3 border-t border-slate-100">
        {stats.map((s) => (
          <div key={s.k} className="text-center" data-testid={`agent-stat-${s.k}`}>
            <p className="text-[11px] text-slate-400">{s.label}</p>
            <p className="text-sm font-bold text-slate-800">{s.v}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
